import { render } from "./DefaultSvgVideo.vue?vue&type=template&id=a0e46b64&scoped=true"
import script from "./DefaultSvgVideo.vue?vue&type=script&lang=js"
export * from "./DefaultSvgVideo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/carolinehansen/Sites/work-manyone/koebenhavns-kommune/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0e46b64"]])

export default __exports__